import { MATERIAL_OPTION_TEXTS } from '../constants/materialOptionTexts';

/**
 * Opciones de grupo de materiales: nombre y, en la segunda línea, código y cantidad de
 * materiales.
 * @param {Array<Object>} groups Grupos del catálogo.
 * @returns {Array<{value: string, label: string, secondary: string}>}
 */
export const toMaterialGroupOptions = (groups = []) =>
  groups.map((group) => ({
    value: group.uuid,
    label: group.name || group.code || '',
    secondary: [
      group.code,
      Array.isArray(group.articles) ? MATERIAL_OPTION_TEXTS.members(group.articles.length) : '',
    ]
      .filter(Boolean)
      .join(' · '),
  }));
